/**
 * Shared class metadata used by the chargen wizard (C10) and the reuse-party
 * fork path (P22). Duplicating this inline across multiple components was
 * fine when only the wizard needed it; the launch-gate reuse path now needs
 * to derive L1 stats from a source character's `characterClass` id, so the
 * table moves here.
 *
 * This is intentionally a tiny local table — not a DataRegistry fetch —
 * because the wizard is hardcoded to these five classes for v1. When the
 * class roster becomes data-driven, this module goes away.
 */

export interface ClassData {
  readonly id: string;
  readonly label: string;
  readonly maxHp: number;
  readonly ac: number;
  readonly spellSlots?: Record<number, number>;
  /** EV-E7 — casting stat for roster-provided custom classes. */
  readonly castingAbility?: import("../types/entity.js").AbilityName;
}

export const CLASS_TABLE: readonly ClassData[] = [
  { id: "fighter", label: "Fighter", maxHp: 12, ac: 16 },
  { id: "wizard", label: "Wizard", maxHp: 6, ac: 12, spellSlots: { 1: 2 } },
  { id: "rogue", label: "Rogue", maxHp: 8, ac: 14 },
  { id: "cleric", label: "Cleric", maxHp: 8, ac: 16, spellSlots: { 1: 2 } },
  { id: "ranger", label: "Ranger", maxHp: 10, ac: 14 },
];

export function findClassData(id: string): ClassData | undefined {
  return CLASS_TABLE.find((c) => c.id === id);
}
